let util = {
    formCheck:{}
}

// 银行卡号正则验证 62122 62502 00918 2455
util.formCheck.bankCard = (rule, value, callback) => {
    if(!value) {
        callback(new Error('银行卡号不存在'));
    }else if(!(new RegExp("^([1-9]{1})(\\d{14}|\\d{18})$").test(value.toString().replace(/\s/g, "")))){
        callback(new Error('请输入正确的银行卡号'));
    }else{
        callback();
    }
};
// 身份证验证 440981200102076416
util.formCheck.idCard = (rule, value, callback) => {
    if(!value) {
        callback(new Error('法人身份证号不存在'));
    }else if(!(new RegExp("^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$").test(value.toString().replace(/\s/g, "")) || new RegExp("^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$").test(value.toString().replace(/\s/g, "")))){
        callback(new Error('请输入正确的法人身份证号'));
    }else{
        callback();
    }
};

//610103100025511 营业执照
util.formCheck.licenseNumber = (rule, value, callback) => {
    if(!value) {
        callback(new Error('营业执照不存在'));
    }else if(!(new RegExp("^\\d{15}$").test(value.toString().replace(/\s/g, ""))|| new RegExp("^(?:(?![IOZSV])[\\dA-Z]){2}\\d{6}(?:(?![IOZSV])[\\dA-Z]){10}$").test(value.toString().replace(/\s/g, "")) ) ){
        callback(new Error('请输入正确的营业执照号'));
    }else{
        callback();
    }
};

//13905083112 手机号码
util.formCheck.mobile = (rule, value, callback) => {
    if(!value) {
        callback(new Error('手机号码不存在'));
    }else if(!(new RegExp("^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$").test(value.toString().replace(/\s/g, "")))){
        callback(new Error('请输入正确的手机号码'));
    }else{
        callback();
    }
};

// 数字保证金 只能是数字且只有一个小数点
util.formCheck.bailPaid = (rule, value, callback) => {
    if(!value) {
        callback(new Error('数额不存在'));
    }else if(!(new RegExp("^\\d*\\.{0,1}\\d{0,1}$").test(value.toString().replace(/\s/g, "")))){
        callback(new Error('请输入正确的数额'));
    }else{
        callback();
    }
};

// 数字 只能是数字且只有一个小数点
util.formCheck.num = (rule, value, callback) => {
    if(!value) {
        callback(new Error('数字不存在'));
    }else if(!(new RegExp("^[0-9]*$").test(value.toString().replace(/\s/g, "")))){
        callback(new Error('请输入正确的数字'));
    }else{
        callback();
    }
};
// 邮箱
util.formCheck.email = (rule, value, callback) => {
    if(!value) {
        callback(new Error('邮箱不存在'));
    }else if(!(new RegExp("^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$").test(value.toString().replace(/\s/g, "")))){
        callback(new Error('请输入正确的邮箱'));
    }else{
        callback();
    }
};

// 邮编
util.formCheck.zipCode = (rule, value, callback) => {
    if(!value) {
        callback(new Error('邮编不存在'));
    }else if(!(new RegExp("^[1-9]\\d{5}$").test(value.toString().replace(/\s/g, "")))){
        callback(new Error('请输入正确的邮编'));
    }else{
        callback();
    }
};


export default util